<div
    class="picker-wrapper"
    [ngClass]="{
        'no-brand-colors': !displayBrandColors,
        'picker-open': chooseColorPickerKey === key,
    }"
    (click)="$event.stopPropagation()">
    <ng-container *ngIf="chooseColorPickerKey !== key; else colorPickerBlock">
        <div class="section">
            <p>Recently Used</p>
            <div class="swatch-row">
                <div>
                    <div class="swatch add" (click)="openColorPicker(key); $event.stopPropagation()">+</div>
                </div>
                <div
                    class="swatch"
                    *ngFor="let color of recentlyUsedColors"
                    [style.background]="color"
                    (click)="selectColor(key, color)"></div>
            </div>
        </div>

        <div *ngIf="this.displayBrandColors" class="section">
            <p>Brand palette</p>
            <div class="swatches">
                <div
                    class="swatch"
                    *ngFor="let color of brandPalette"
                    [style.background]="color"
                    (click)="selectColor(key, color)"></div>
            </div>
        </div>
    </ng-container>
    <ng-template #colorPickerBlock>
        <div class="color-pick-with-buttons" (click)="$event.stopPropagation()">
            <span
                [style.background]="tempColor"
                [cpToggle]="true"
                [cpDialogDisplay]="'inline'"
                [cpWidth]="'170px'"
                [sliderHeight]="100"
                [(colorPicker)]="tempColor">
            </span>
            <div class="button-row">
                <button mat-icon-button (click)="cancelColor()">
                    <mat-icon>arrow_back</mat-icon>
                </button>

                <button
                    mat-raised-button
                    color="primary"
                    class="pick-button"
                    (click)="colorChosenFromPicker(key, tempColor)">
                    Pick
                </button>
            </div>
        </div>
    </ng-template>
</div>
